import { useAccount } from 'reservations/account/providers/AccountProvider';

export function useHasCloverOptInMessageFeature() {
  const { has_clover_opt_in_messages_feature } = useAccount();

  return has_clover_opt_in_messages_feature;
}

export const useHasGuestInvitationsFeature = () => {
  const { has_guest_invitations_feature, has_booking_api_v2_feature } =
    useAccount();
  return has_guest_invitations_feature && has_booking_api_v2_feature;
};

export const useHasCheckSplittingFeature = () => {
  const { has_check_splitting_feature } = useAccount();
  return has_check_splitting_feature;
};
